import { SignalProp, unwrapNetworkResponse } from './fetch-core';
import { makeAuthenticatedNetworkRequest } from './aws-fetch.ts';
import { fillRoute } from '../../utils/fill-route.ts';

export interface AddSaveSearchReqBody {
  id?: number | string;
  apn?: string;
  state?: string;
  zip?: string;
  county?: string;
  city?: string;
  address?: string;
  mlsListingPriceMin?: number;
  mlsListingPriceMax?: number;
  lotSizeMin?: number;
  lotSizeMax?: number;
  includeNonVacantLots?: boolean;
  mlsPending?: boolean;
  mlsCancelled?: boolean;
  size?: number;
  vacant?: boolean;
  resultIndex?: number;
  searchName: string;
  sub: string;
}

export interface SaveSearchResType {
  id?: number | string;
  apn?: string;
  state?: string;
  zip?: string;
  county?: string;
  city?: string;
  address?: string;
  mlsListingPriceMin?: number;
  mlsListingPriceMax?: number;
  lotSizeMin?: number;
  lotSizeMax?: number;
  includeNonVacantLots?: boolean;
  mlsPending?: boolean;
  mlsCancelled?: boolean;
  size?: number;
  vacant?: boolean;
  resultIndex?: number;
  searchName?: string;
  createdOn?: string;
}

const savedSearchBaseUrl = import.meta.env
  .VITE_PRIVATE_API_GATEWAY_URL as string;

export const addSavedSearchUrl = `/land/search/saved`;

interface AddSaveSearchReqType {
  body: AddSaveSearchReqBody;
}

export async function addSavedSearch({
  signal,
  body,
}: SignalProp & AddSaveSearchReqType) {
  const res = await makeAuthenticatedNetworkRequest({
    method: 'PUT',
    baseUrl: savedSearchBaseUrl,
    relativeUrl: addSavedSearchUrl,
    signal,
    body,
  });

  const data = await unwrapNetworkResponse<SaveSearchResType>(res);
  return data;
}

export const getSavedSearchUrl = `/land/search/saved/:sub`;

interface GetSearchReqType {
  sub: string;
}

export async function getSavedSearch({
  signal,
  sub,
}: SignalProp & GetSearchReqType) {
  const relativeUrl = fillRoute(getSavedSearchUrl, {
    sub,
  });

  const res = await makeAuthenticatedNetworkRequest({
    method: 'GET',
    baseUrl: savedSearchBaseUrl,
    relativeUrl: relativeUrl,
    signal,
  });

  const data = await unwrapNetworkResponse<SaveSearchResType[]>(res);
  return data;
}

export const deleteSavedSearchUrl = `/land/search/saved/:sub`;

interface DeleteSearchReqType {
  sub: string;
  searchName: string;
}

export async function deleteSavedSearch({
  signal,
  sub,
  searchName,
}: SignalProp & DeleteSearchReqType) {
  const relativeUrlBase = fillRoute(deleteSavedSearchUrl, {
    sub,
  });

  const res = await makeAuthenticatedNetworkRequest({
    method: 'DELETE',
    baseUrl: savedSearchBaseUrl,
    relativeUrl: `${relativeUrlBase}?searchName=${searchName}`,
    signal,
  });

  const data = await unwrapNetworkResponse<SaveSearchResType>(res);
  return data;
}
